import { useRouter } from 'next/router';

import { Grid, Typography } from '@mui/material';

import { LearnWithUs, ReasonList } from './style';

import { ReasonItem } from '@components/molecules/academicLandingPage/reasonItem';
import { useBreakpointV2, useUniversityInformation } from '@helpers/use';

export const LearnWithUsSection = () => {
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);
  const { isTablet } = useBreakpointV2();

  const learnWithUsInformationCount = landingPage?.universityLearnWithUsInformations?.length || 0;

  const isOdd = learnWithUsInformationCount % 2;

  return (
    <LearnWithUs>
      <Typography
        variant="h4"
        marginBottom={{ xs: 3, md: 6 }}
        textAlign="center"
        fontSize={{ sm: 30 }}
        lineHeight={{ xs: '24px', sm: '34px' }}
        fontWeight={700}
        color="#000000DE"
      >
        {landingPage?.learnWithUsSectionHeading}
      </Typography>
      <ReasonList>
        <Grid container justifyContent="center">
          {landingPage?.universityLearnWithUsInformations?.length &&
            landingPage?.universityLearnWithUsInformations.map((item) => (
              <Grid xs={12} md={6} lg={3} item>
                <ReasonItem
                  imageUrl={item.imageUrl}
                  title={item.title}
                  description={item.description}
                  key={`Learn With Us ${item.title}`}
                />
              </Grid>
            ))}
          {isTablet && isOdd && <Grid md={6} item />}
        </Grid>
      </ReasonList>
    </LearnWithUs>
  );
};
